import "./OutputDownload.css";


function OutputDownload(props){

    const downloadTxtFile = () => {
        // text content
        const texts = props.text;
        // file object
        const file = new Blob([texts], {type: 'text/plain'});
        // anchor link
        const element = document.createElement("a");
        element.href = URL.createObjectURL(file);
        element.download = "Translated_" + Date.now() + ".smv";
        // simulate link click
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
    }
    return (
        <div className="btndiv">
        { props.text ? (
            <button classname="downloadBtn" onClick={downloadTxtFile}>Download</button>
            
        ) : ""}
    </div>
    );
}

export default OutputDownload;
